// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notif-bell-wrapper {
  position: relative;
}

.notif-bell-btn {
  position: relative;
  background: #0a0a0a;
  border: 1.5px solid #333333;
  border-radius: 9px;
  padding: 7px 10px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.15s ease;
  line-height: 1;
}

.notif-bell-btn:hover {
  background: #1a1a1a;
  border-color: #ffffff;
}

.notif-bell-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ffffff;
  color: #000000;
  font-size: 10px;
  font-weight: 800;
  border-radius: 999px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.5);
}

.notif-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 320px;
  max-height: 400px;
  background: #0a0a0a;
  border: 1.5px solid #333333;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.notif-dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid #333333;
  font-size: 13px;
  font-weight: 800;
  color: #ffffff;
}

.notif-mark-all {
  background: none;
  border: none;
  color: #cccccc;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

.notif-mark-all:hover {
  color: #ffffff;
}

.notif-list {
  overflow-y: auto;
  max-height: 340px;
}

.notif-empty {
  padding: 24px 14px;
  text-align: center;
  color: #999999;
  font-size: 12px;
}

.notif-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  text-align: left;
  padding: 11px 14px;
  background: none;
  border: none;
  border-bottom: 1px solid #222222;
  cursor: pointer;
  transition: background 0.15s ease;
}

.notif-item:hover {
  background: #1a1a1a;
}

.notif-item--unread {
  background: rgba(255, 255, 255, 0.06);
}

.notif-item-title {
  font-size: 12.5px;
  font-weight: 800;
  color: #ffffff;
}

.notif-item-body {
  font-size: 11.5px;
  color: #cccccc;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/NotificationBell.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".notif-bell-wrapper {\n  position: relative;\n}\n\n.notif-bell-btn {\n  position: relative;\n  background: #0a0a0a;\n  border: 1.5px solid #333333;\n  border-radius: 9px;\n  padding: 7px 10px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  line-height: 1;\n}\n\n.notif-bell-btn:hover {\n  background: #1a1a1a;\n  border-color: #ffffff;\n}\n\n.notif-bell-badge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background: #ffffff;\n  color: #000000;\n  font-size: 10px;\n  font-weight: 800;\n  border-radius: 999px;\n  min-width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 3px;\n  box-shadow: 0 0 6px rgba(255, 255, 255, 0.5);\n}\n\n.notif-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 320px;\n  max-height: 400px;\n  background: #0a0a0a;\n  border: 1.5px solid #333333;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.notif-dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid #333333;\n  font-size: 13px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.notif-mark-all {\n  background: none;\n  border: none;\n  color: #cccccc;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n}\n\n.notif-mark-all:hover {\n  color: #ffffff;\n}\n\n.notif-list {\n  overflow-y: auto;\n  max-height: 340px;\n}\n\n.notif-empty {\n  padding: 24px 14px;\n  text-align: center;\n  color: #999999;\n  font-size: 12px;\n}\n\n.notif-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100%;\n  text-align: left;\n  padding: 11px 14px;\n  background: none;\n  border: none;\n  border-bottom: 1px solid #222222;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.notif-item:hover {\n  background: #1a1a1a;\n}\n\n.notif-item--unread {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.notif-item-title {\n  font-size: 12.5px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.notif-item-body {\n  font-size: 11.5px;\n  color: #cccccc;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
